'use client';

import React, { useRef, useEffect } from 'react';

interface HtmlViewClientProps {
  html: string | null | undefined;
}

const HtmlViewClient = ({ html }: HtmlViewClientProps) => {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const container = containerRef.current;
    if (!container || !html) return;

    const handleClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement;

      // Walk up the DOM tree in case of nested elements inside <a>
      const anchor = target.closest('a');
      if (!anchor || !container.contains(anchor)) return;

      const href = anchor.getAttribute('href');
      if (href && href.startsWith('#')) {
        e.preventDefault(); // prevent browser default (URL change)

        const id = href.slice(1);
        const el = container.querySelector<HTMLElement>(`#${CSS.escape(id)}`);
        if (el) {
          el.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'start' });
        }
      }
    };

    container.addEventListener('click', handleClick);
    return () => container.removeEventListener('click', handleClick);
  }, [html]);

  return <div ref={containerRef} dangerouslySetInnerHTML={{ __html: html ?? '' }} />;
};

export default HtmlViewClient;
